import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {AidantService} from '../../_services';
import {Aidant} from '../../_models';
import {first} from 'rxjs/operators';
import {getCurrentAbeille} from '../../../assets/utils.js';

@Component({
  selector: 'app-add-aidant',
  templateUrl: './add-aidant.component.html',
  styleUrls: ['./add-aidant.component.scss']
})
export class AddAidantComponent implements OnInit {

    @Output() refreshEvent = new EventEmitter<string>();

    show = true;
    patientId = '';
    uploading = false;

    aidantForm = new FormGroup({
        name: new FormControl(''),
        role: new FormControl(''),
        phonePrefix: new FormControl('+33'),
        phone: new FormControl(''),
    });

    constructor(private aidantService: AidantService) {
        this.patientId = getCurrentAbeille().id;
    }

    ngOnInit() {
    }


    checkAidantInfos() {
        if (!this.aidantForm.value.name) {
            alert('Nom invalide !');
            return false;
        }
        if (!this.aidantForm.value.role) {
            alert('Rôle invalide !');
            return false;
        }
        if (!this.aidantForm.value.phone) {
            alert('Numéro de téléphone invalide !');
            return false;
        }

        return true;
    }

    onSubmit() {

        if (!this.checkAidantInfos()) {
            return false;
        }

        const aidant = new Aidant({});
        aidant.tempName = this.aidantForm.value.name;
        aidant.role = this.aidantForm.value.role;
        aidant.phonePrefix = this.aidantForm.value.phonePrefix;
        aidant.phone = this.aidantForm.value.phone;
        aidant.enabled = true;
        aidant.generateKey();

        this.uploading = true;

        this.aidantService.registerByPatientId(this.patientId, aidant).pipe(first()).subscribe(result => {
            this.uploading = false;

            this.aidantForm.reset();
            this.refreshEvent.next();
        });
    }

}
